<template>
    <div :data-testid="testId" :class="cssClass">
        <span v-if="hasContent"><RichText :field="{value: content}" tag="span" /></span>&nbsp;
        <a v-if="hasCTA" :href="ctaLink" @click="onCTAClick"  class="text-base-link text-racq-blue underline font-medium">
            {{ ctaLabel }}
        </a>
    </div>
</template>

<script lang="ts" setup>
import { FormEvents } from "@/enums/form-events.enum";
import { useAnalyticsStore } from "@/store";
import { RichText } from "@sitecore-jss/sitecore-jss-vue";
import { computed } from "vue";

export interface BannerProps {
    content?: string;
    ctaLabel?: string;
    ctaLink?: string;
    collapsed?: boolean;
    testId?: string;
}

const { pushClickEvent } = useAnalyticsStore();


const props = defineProps<BannerProps>();

const hasCTA = computed(() => {
    return ctaLabel.value && ctaLabel.value.trim().length > 0;
});

const ctaLabel = computed(() => {
    return props.ctaLabel;
});

const ctaLink = computed(() => {
    return props.ctaLink;
});

const content = computed(() => {
    return props.content;
});

const hasContent = computed(() => {
    return content.value && content.value.trim().length > 0;
});

const testId = computed(() => {
    return props.testId;
});

const cssClass = computed(() => `rounded-md m-4 mb-0 px-4 py-3 bg-racq-info-blue text-sm${props.collapsed === true ? " hidden" : ""}`); 

const onCTAClick = () => {
    pushClickEvent({ 
        event: FormEvents.INTERACTION_LINK_CLICK, 
        eventInfo: { 
            navigation: { 
                id: `link_${props.testId}_cta`,
                url: props.ctaLink || "",
                name: props.ctaLabel || "",
                type: "Link",
                linkClicks: 1,
            }
        }
    });
};

</script>